module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAUklEQVQoFZXBsREDMQzAMHL/oRUWKlLpz4A8kkeyJhwMkTXhYIisCTH8mRBDZE2I4c+EGCJrwsEQWRMOhsiHCTFEPkyIIbImHAyRNeFgiDySRz+XAzAPuuGKrQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_context_09.png
// module id = 231
// module chunks = 0